import { Children, cloneElement, useCallback, useEffect, useState } from 'react';

import { useInterviewLocationGetQuery } from '../../Common/Queries/interviewLocationQueries';
import { useInterviewsPostQuery } from '../../Common/Queries/interviewsQueries';
import { usePanelsApplicationGetQuery } from '../../Common/Queries/panelQueries';
import { usePositionsGetQueryById } from '../../Common/Queries/positionsQueries';
import { useUsersGetQuery } from '../../Common/Queries/usersQueries';

/**
 * this function is utility function for formate the data in required formate
 * @param {*} values interview form values
 * @param {*} applicationId id of application
 * @returns values in required formate
 */
export const formateData = (values, applicationId, round) => {
  const basicInfo = {
    text: values?.text,
    ...(round && { round }),
  };
  const interviewDetails = {
    startTime: Math.floor(new Date(values.startTime) / 1000),
    interviewer: values.interviewer,
    duration: Number(values?.duration),
    location: values?.location || 'ONLINE',
  };

  const otherDetails = {
    timeZone: 'Asia/Kolkata',
    ...(values?.otherDetails || {}),
  };

  const meetingRoom = {
    meetingRoomID: values?.meetingRoomID,
  };

  return {
    interviewDetails,
    otherDetails,
    application: { id: Number(applicationId) },
    basicInfo,
    ...(values.meetingRoomID && meetingRoom),
  };
};

export function AddInterviewContainer({
  children,
  positionDetail,
  applicationId,
  applicationData,
  setOpen,
  round,
  ...props
}) {
  const [search, setSearch] = useState('');
  const [panelConfig, setPanelConfig] = useState({
    duration: '',
    startTime: '',
  });
  const interviewerList = useUsersGetQuery(
    { q: search },
    { enabled: search.length >= 2 } // enable query only if user search something
  );
  const getInterviewLocations = useInterviewLocationGetQuery();
  const postToInterviews = useInterviewsPostQuery();

  const getPanels = usePanelsApplicationGetQuery(
    {
      positionId: positionDetail?.id,
      applicationId,
      ...panelConfig,
    },
    {
      enabled: Boolean(panelConfig?.startTime && panelConfig?.duration),
    }
  );

  const positionData = usePositionsGetQueryById({ reqId: positionDetail?.id });

  function handleSubmitForAddInterview(finalValues) {
    const reqBody = formateData(finalValues, applicationId, round);
    postToInterviews.mutate(reqBody);
  }

  const handleClosePopup = () => setOpen(false);

  /**
   * function to handle search data for Interviewer
   * @param {String} value search input
   */
  const handleSearch = useCallback(() => {
    let timer;
    return (value) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        setSearch(value);
      }, 400);
    };
  }, [setSearch])();

  useEffect(() => {
    if (postToInterviews.isSuccess) {
      setOpen(false);
    }
  }, [postToInterviews.isSuccess]);

  return Children.only(
    cloneElement(children, {
      interviewerList,
      getInterviewLocations,
      handleSearch,
      postToInterviews,
      positionData,
      getPanels,
      handleSubmitForAddInterview,
      handleCloseInterview: handleClosePopup,
      setPanelConfig,
      panelConfig,
      ...props,
    })
  );
}
